import { Avatar, IconButton } from '@mui/material';
import { AlternativeMedicineContext } from 'Context/AlternativeMedicine';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleClose } from 'Images';
import { useContext } from 'react';

export const CloseButton = () => {
  const { handleCloseModal } = useContext(AlternativeMedicineContext);
  const isDesktop = useIsDesktop();

  return (
    <IconButton
      sx={{
        position: 'absolute',
        top: isDesktop ? '24px' : '20px',
        right: '24px',
      }}
      onClick={handleCloseModal}
    >
      <Avatar
        sx={isDesktop ? undefined : { width: '32px', height: '32px' }}
        alt={Dictionary[DICTIONARY.General].close}
        src={PurpleClose}
      />
    </IconButton>
  );
};
